// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__1kl9P","header":"Dialog_header__5Y0XH","closeButton":"Dialog_closeButton__3dIdr Inputs_input__3H5nv"};